import logo from "./logo.svg";
import "./App.css";
import Routes from "./Routes/Routes";
import DashBoard from "./DashBoard/DashBoard";
import { useState } from "react";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import Context from "./Contex/Context";
import CircularProgress from "@mui/material/CircularProgress";
import { useContext } from "react";
function App() {
  const history = useHistory();
  const { authenticate, setAuthenticate } = useContext(Context);
  const userDetails = JSON.parse(localStorage.getItem("MailSenderuserDetails"));
  const [status, setStatus] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setStatus(false);
    }, 500);
    if (userDetails === null) {
      setAuthenticate(false);
    } else {
      setAuthenticate(true);
    }
  }, []);
  // console.log("auhenticate",authenticate)
  return (
    <>
      {status ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <CircularProgress
            size={60}
            style={{
              color: "#1C485F",
            }}
          />
        </div>
      ) : (
        <div className="body">{authenticate ? <DashBoard /> : <Routes />}</div>
      )}
    </>
  );
}

export default App;
